document.addEventListener('DOMContentLoaded', function(){
    iniciarApp();
});

function iniciarApp() {
    navegacionFija();
    crearGaleria();
    scrollNav();
}

function navegacionFija() {
    const barra = document.querySelector('.header'); // seleccionamos el header del html
    const sobreFestival = document.querySelector('.sobre-festival');
    const body = document.querySelector('body');

    window.addEventListener('scroll', function() {
        if(sobreFestival.getBoundingClientRect().top < 0) {
            barra.classList.add('fijo'); // le pasamos la clase fijo a la barra si la pasamos
            body.classList.add('body-scroll');
        } else {
            barra.classList.remove('fijo');
            body.classList.remove('body-scroll');
        }

    })

}

// para realizar un scroll smooth
function scrollNav() {
    const enlaces = document.querySelectorAll('.navegacion-principal a');
    enlaces.forEach(enlace => {
        enlace.addEventListener('click', function(e){
            e.preventDefault(); // para prevenir el comportamiento por default (scroll inmediato)
            const seccionScroll =  e.target.attributes.href.value; // e.target me entrega la etiqueta <a> entera. attributes accede a los atributos, href y nos entrega: href="#lineup" y value nos entrega unicamente #lineup, todo esto, en el momento de hacer click si tuvieramos un console.log lo podriamos ver.
            const seccion = document.querySelector(seccionScroll);
            seccion.scrollIntoView({behavior: 'smooth'});
        });
    });
}

function crearGaleria() {
    const galeria = document.querySelector('.galeria-imagenes');
    //galeria.textContent = 'Vamos a crear la galería';

    // recorremos todas las imagenes y las representamos (forma para cuando hay muchas imagenes)
    for(let i = 1; i <= 12; i++) {
        const imagen = document.createElement('picture');
        imagen.innerHTML = `
            <source srcset="build/img/thumb/${i}.avif" type="image/avif">
            <source srcset="build/img/thumb/${i}.webp" type="image/webp">
            <img loading="lazy" width="200" height="300" src="build/img/thumb/${i}.jpg" alt="Imagen Galería"> 
        `;

        // para mostrar la imagen cuando demos un click
        imagen.onclick = function() {
            mostrarImagen(i);
        }

        galeria.appendChild(imagen);
    }
}

function mostrarImagen(id) {
    const imagen = document.createElement('picture');
    imagen.innerHTML = `
        <source srcset="build/img/grande/${id}.avif" type="image/avif">
        <source srcset="build/img/grande/${id}.webp" type="image/webp">
        <img loading="lazy" width="200" height="300" src="build/img/grande/${id}.jpg" alt="Imagen Galería"> 
    `;

    // creamos un div y le añadimos una imagen y ademas le asignamos una clase
    const overlay = document.createElement('DIV');
    overlay.appendChild(imagen);
    overlay.classList.add('overlay');
    overlay.onclick = function() {
        const body = document.querySelector('body'); // para cerrar el overlay cuando hagamos click en cualquier sitio de la pantalla que no sea el overlay
        body.classList.remove('fijar-body');
        overlay.remove();
    }

    // boton para cerrar el modal (foto)
    const cerrarModal = document.createElement('P'); // creamos etiqueta
    cerrarModal.textContent = 'X'; // ponemos el texto del parrafo
    cerrarModal.classList.add('btn-cerrar'); // creamos clase
    cerrarModal.onclick = function() {
        const body = document.querySelector('body');
        body.classList.remove('fijar-body'); // para eliminar la funcion que no permite dar scroll una vez cerramos el overlay
        overlay.remove(); // eliminamos el overlay (la imagen desplegada)
    }
    overlay.appendChild(cerrarModal); // añadimos boton al overlay

    // lo añadimos al html
    const body = document.querySelector('body');
    body.appendChild(overlay);

    // para impedir hacer scroll cuando este el overlay
    body.classList.add('fijar-body');
}